import { SortableHandle } from 'react-sortable-hoc'

const DragHandle = SortableHandle(() => <div className={'btn btn-default preact-drag-handle'}>
  <i className={'icon-reorder'} />
</div>)

export default DragHandle
